<template>
  <div class="needsValidation page-container">
    <div class="page-title">
      {{ $t('menu.online_payout') }}
    </div>
    <div class="filter-container">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickBackBtn" />
        <span @click="onClickBackBtn">{{ $t('customerService.payment_details') }}</span>
      </div>
      <div class="btn-container">
        <el-button
          v-if="status === statusObj['Needs_Validation']
          "
          class="mb-10 download-btn"
          type="danger"
          size="small"
          icon="el-icon-delete"
          @click="onClickDeleteBtn"
        >{{ $t('components.delete') }}</el-button>
      </div>

      <!-- <UploadExcelFile
        :merchant-id="merchantId"
        class="mt5 "
        :limit-num="1"
        @templateFileSuccess="templateFileSuccess"
      /> -->
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="status === statusObj['Needs_Validation']"
          type="selection"
          width="55"
        />
        <!-- <el-table-column label="Date Created" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column> -->

        <el-table-column v-if="status === statusObj['Approved']" :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_id }}
          </template>
        </el-table-column>

        <!-- <el-table-column v-if="status === statusObj['Approved']" :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            {{ scope.row.merchant_order_id }}
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('customerService.reference')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reference_batch_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.recipient_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.full_name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Recipient Account Number" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Account Name" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('components.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toThousandFilter }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="Service Fee" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.service_fee }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          v-if="status !== statusObj['Approved']"
          :label="$t('customerService.validation')"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">

            <el-tooltip v-if="scope.row.unvalidated_fields && scope.row.unvalidated_fields.length >0" placement="top">
              <div slot="content">
                <span>{{ scope.row.unvalidated_fields.join(',') }}</span>
              </div>
              <el-tag type="danger" class="tag-custom">{{ scope.row.unvalidated_fields.join(',') }}</el-tag>
            </el-tooltip>

            <el-tag v-else type="success" class="tag-custom">Passed</el-tag>

          </template>
        </el-table-column>

        <!-- <el-table-column label="Email" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.email }}</span>
          </template>
        </el-table-column> -->

        <el-table-column v-if="status === statusObj['Approved']" :label="$t('merchantAccount.transaction_status')" min-width="150" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPOTransactionStatusType(scope.row.transaction_status)"> {{ getPOTransactionStatusMap(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column v-if="status === statusObj['Approved']" :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="Remark" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column> -->

        <el-table-column v-if="status === statusObj['Approved']" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="status === statusObj['Approved']" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">

            <el-tooltip v-if="[statusObj['Needs_Validation'],statusObj['Checker']].includes(status) " placement="top">
              <div slot="content">
                <span> {{ $t('components.edit') }}</span>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-edit" @click="onClickEditBtn(scope.row)" />
            </el-tooltip>

            <el-tooltip v-if="status === statusObj['Needs_Approval']" placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickNeedsApprovalDetail(scope.row)" />
            </el-tooltip>

            <el-tooltip v-if="status === statusObj['Approved']" placement="top" :class="{disabled:!scope.row.transaction_status}">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>

            <el-tooltip v-if="scope.row.transaction_status === 4" placement="top">
              <div slot="content">
                <span> {{ $t('components.retry') }}</span>
              </div>
              <svg-icon size="mini" type="warning" class-name="icon-function" icon-class="retry" @click="onClickRetryBtn(scope.row)" />
            </el-tooltip>

          </template>
        </el-table-column>

      </el-table>
      <SingleDisbursementEditModal ref="singleDisbursementEditModal" @getDisbursementRefernceDetail="getDisbursementRefernceDetail" />
      <NeedsApprovalDetail ref="needsApprovalDetail" />
      <po-details-modal ref="poMentDetailsModal" :detail-id="detailId" />
    </div>
  </div>
</template>

<script>

import { fetchDisbursementRefernceDetail, fetchDisbursementRefernceDetailWithTrans, deleteDisbursementDetailData, retryDisbursementData } from '@/api/online-transaction/online-transaction'
import { poTransStatusMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
import SingleDisbursementEditModal from './components/Modal/SingleDisbursementEditModal.vue'
import NeedsApprovalDetail from './components/Modal/NeedsApprovalDetail.vue'
export default {
  name: 'Detail_Disbursement',
  components: {
    SingleDisbursementEditModal,
    NeedsApprovalDetail,
    PoDetailsModal: () => import('@/views/paycools/data/components/Modal/PoDetailsModal')
  },
  data() {
    this.statusObj = {
      'Needs_Validation': 0,
      'Needs_Approval': 1,
      'Approved': 2,
      'Checker': 4
    }
    return {
      detailId: '0',
      status: null,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return poTransStatusMap(value).label
      }
    }
  },
  created() {
    const { status } = this.$route.params
    this.status = Number(status)
    this.getDisbursementRefernceDetail()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getDisbursementRefernceDetail() {
      this.listLoading = true
      const { id } = this.$route.params
      const params = {
        reference_batch_no: id
      }
      let event = fetchDisbursementRefernceDetail
      if (this.status === this.statusObj['Approved']) {
        event = fetchDisbursementRefernceDetailWithTrans
      }
      event(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data || []
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { payment_status, times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], payment_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getDisbursementRefernceDetail(params)
    },

    onClickDeleteBtn() {
      if (!Array.isArray(this.multipleSelection) || this.multipleSelection.length <= 0) {
        this.$message.warning('Please select the left first and then delete!')
        return
      }
      const keyArr = this.multipleSelection.map(item => item.row_key)
      deleteDisbursementDetailData({ delete_key_list: keyArr }).then(res => {
        if (res.code === 10000) {
          this.$message.success('Delete Successfully')
          this.getDisbursementRefernceDetail()
        }
      })
    },

    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickEditBtn(row) {
      this.$refs.singleDisbursementEditModal.changModalStatus({
        status: true,
        value: row
      })
    },
    onClickNeedsApprovalDetail(row) {
      this.$refs.needsApprovalDetail.changModalStatus({
        status: true,
        value: row
      })
    },
    onClickRetryBtn(row) {
      const params = { row_key: row.row_key }
      retryDisbursementData(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Retry Successfully')
          this.getDisbursementRefernceDetail()
        }
      })
    },
    onClickBackBtn() {
      this.$router.push({ name: 'Online_Transaction_Payout_Approval', query: { status: this.status }})
    },

    onClickDetailTxt(row) {
      if (row.transaction_status) {
        this.detailId = row.transaction_id
        this.showPayDetailModal()
      }
    },

    showPayDetailModal() {
      this.$refs.poMentDetailsModal.changModalStatus(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.needsValidation{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }

  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .disabled{
    cursor: no-drop;
  }
}

</style>
